import { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DisposalModal from '../components/disposal-modal/DisposalModal';
import { getApplication } from '../modules/app/actions';
import { getConsolidationInfo } from '../modules/car-consolidation-loan/actions';
import {
  getCreditInstitution,
  getDisposalInformation,
  initializeDisposalState,
  postDisposalInformation,
  setApplicationToSign,
  setShowDigitalSignModal,
  setShowDisposalModal,
} from '../modules/applications/actions';

export default (applicationInfo = {}) => {
  const { disposalModal, disposalInformation, creditInstitutions } = useSelector(
    (state) => state.applications,
  );
  const app = useSelector((state) => state.app);
  const consolidation = useSelector((state) => state.consolidation);
  const { location } = useSelector((state) => state.router);

  const isConsolidation = location.pathname.includes('/car-consolidation-loan');

  // Get year, serialNumber, and sendDisposalInformation from appropriate state
  const year = isConsolidation ? consolidation.year : app.year;
  const serialNumber = isConsolidation ? consolidation.serialNumber : app.serialNumber;
  const sendDisposalInformation = isConsolidation
    ? consolidation.disposalInformation
    : app.sendDisposalInformation;

  const application = {
    year: applicationInfo.year || year,
    serialNumber: applicationInfo.serialNumber || serialNumber,
    sendDisposalInformation: applicationInfo.sendDisposalInformation || applicationInfo.disposalInformation || sendDisposalInformation,
  };

  const dispatch = useDispatch();
  useMemo(() => {
    if (disposalModal.show && creditInstitutions.status === 'initial') {
      dispatch(getCreditInstitution());
    }
  }, [disposalModal.show, creditInstitutions.status]);

  useMemo(
    () => () => {
      if (disposalInformation.status !== 'initial') {
        dispatch(initializeDisposalState());
      }
    },
    [disposalInformation.status],
  );
  const modal = {
    onClose: () => {
      dispatch(setShowDisposalModal(false));
    },
    onCancel: () => {
      dispatch(setShowDisposalModal(false));
    },
    onOpen: () => {
      if (isConsolidation) {
        if (consolidation.year !== application.year || consolidation.serialNumber !== application.serialNumber) {
          dispatch(getConsolidationInfo(application));
        }
      } else {
        if (app.year !== application.year || app.serialNumber !== application.serialNumber) {
          dispatch(getApplication(application.year, application.serialNumber));
        }
      }

      if (creditInstitutions.status === 'initial') {
        dispatch(getCreditInstitution());
      }
      if (application.year && application.serialNumber) {
        dispatch(
          getDisposalInformation(
            { year: application.year, serialNumber: application.serialNumber },
            application.sendDisposalInformation === 'D',
          ),
        );
      }
      dispatch(setShowDisposalModal(true));
    },
    onSign: (payload) => {
      dispatch(
        postDisposalInformation({
          year: application.year,
          serialNumber: application.serialNumber,
          ...payload,
        }),
      ).then(() => {
        if (isConsolidation) {
          dispatch(getConsolidationInfo(application)).then((res) => {
            dispatch(setShowDigitalSignModal(true));
            return dispatch(setApplicationToSign(res.data));
          });
        } else {
          dispatch(getApplication(application.year, application.serialNumber)).then((res) => {
            dispatch(setShowDigitalSignModal(true));
            return dispatch(setApplicationToSign(res));
          });
        }
        return dispatch(setShowDisposalModal(false));
      });
    },
    sendToSigning: () => {
      dispatch(setApplicationToSign(isConsolidation ? consolidation : app));
      dispatch(setShowDigitalSignModal(true));
      return dispatch(setShowDisposalModal(false));
    },
  };

  return {
    modal,
    showModal: disposalModal.show,
    setShowDisposalModal: (show) => dispatch(setShowDisposalModal(show)),
    DisposalModal,
  };
};
